module.exports = __webpack_public_path__ + "static/UAmobSlide1-87a321c417680dc1bc3a1e25c8c607e1.jpg";